import { render } from "./IconCross.vue?vue&type=template&id=f490f3c4"
const script = {}

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__